export default "__VITE_ASSET__Ci8HdhuJ__"